<div  class="container-fluid container-background">

    <!-- header row top bar contains title, menu, options -->
    <div class="row">

        <!-- affixed header box sets padding for right menu -->
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">

        <div class="outer">
        <div class="middle">

        <div class="login-form-container">

            <div class="login-header-title">
                <i  class="zmdi zmdi-lock zdmi-fw"></i> Your account is on hold.
            </div>

            <div *ngIf="isChild">

                <p>
                    Contact your Pro Teams Administrator to re-enable syncing on your account.
                Need help? <span (click)="openContactSupport()" class="syncblue showhand" id="acct-status-contact-support">Contact Sync customer service</span>.</p>
            </div>


            <div *ngIf="validRenewLink">
                <p>We were not able to automatically renew your account. You’ll need to renew your account to get syncing again. </p>
                <p>
                    <button
                        id="btn-renew-accthold"
                        type="submit"
                        class="btn btn-primary btn-lg showhand"
                        (click)="renewAcctHold()"
                    >Renew now</button>
                </p>
                <p>Need help? <span (click)="openContactSupport()" class="syncblue showhand" id="acct-status-contact-support">Contact Sync customer service</span>.</p>
                <br /><br />
                <p><small>If you wish to close your account, please
                    <span (click)="openCloseAcct()" class="syncblue showhand" id="acct-status-cancel-acct">submit a request</span></small></p>
            </div>

            </div> <!-- login form conteiner -->

            </div> <!-- middle -->
            </div> <!-- outer -->


        </div>
        <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
            <!-- future -->

        </div>



    </div> <!-- row -->

    </div>
